import { getShouldForwardPropFn } from './getShouldForwardPropFn';

export const getStyledOptions = <T extends Record<string, unknown>>(propsToOmit?: (keyof T)[]) => ({
  shouldForwardProp: getShouldForwardPropFn<T>(propsToOmit),
});
